import React from 'react';
import './DeliverySectionNav.css';

/**
 * DeliverySectionNav Component
 * 
 * Right-side section navigation dots for quick access to form sections.
 * Only visible on WHO tab - shows: Business Partners, Contract/Legal
 */
const DeliverySectionNav = ({ activeSection, onSectionClick, visible = true }) => {
  const sections = [
    { id: 'business-partners', label: 'Business Partners' },
    { id: 'contract-legal', label: 'Contract/Legal' }
  ];

  // Only render when visible (WHO tab only)
  if (!visible) return null;

  return (
    <div className="delivery-section-nav">
      {sections.map((section) => (
        <div
          key={section.id}
          className={`delivery-section-nav-item ${
            activeSection === section.id ? 'active' : ''
          }`}
          onClick={() => onSectionClick(section.id)}
          title={section.label}
        >
          <span className="delivery-section-nav-label">{section.label}</span>
          <div
            className={`delivery-section-nav-dot ${
              activeSection === section.id ? 'active' : ''
            }`}
          />
        </div>
      ))}
    </div>
  );
};

export default DeliverySectionNav;

